import React, { useState } from 'react';
import ApiClient from '../../utils/ApiClient';

const QUICK = ['Waiting on violator', 'Discontinued', 'Already ordering elsewhere', 'Bad data'];

export default function SkipModal({ asin, bucket, reasons, fbaAvailable, onClose, onSaved }) {
    const [text, setText] = useState('');
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState(null);
    const save = async () => {
        setBusy(true); setError(null);
        try {
            await ApiClient.post('/api/po-creation/skip', {
                asin, reasonText: text.trim(), bucket, reasons: (reasons || []).map(r => r.code), fbaAvailable,
            });
            onSaved();
        } catch (e) {
            setError('Could not save the skip: ' + e.message);
        } finally { setBusy(false); }
    };
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40" data-testid="skip-modal">
            <div className="bg-white rounded-lg shadow-xl p-5 w-full max-w-md">
                <h3 className="text-lg font-semibold">Skip {asin}</h3>
                <p className="text-sm text-gray-600 mt-1">Why aren't we ordering this? It comes back if it gets more urgent, a new reason appears, stock falls 25%, or in 30 days.</p>
                <div className="flex flex-wrap gap-2 mt-3">
                    {QUICK.map(q => (
                        <button key={q} type="button" onClick={() => setText(q)}
                                className={`px-2 py-1 text-xs rounded border ${text === q ? 'bg-indigo-600 text-white border-indigo-600' : 'border-gray-300 text-gray-700'}`}>{q}</button>
                    ))}
                </div>
                <textarea className="mt-3 w-full border border-gray-300 rounded p-2 text-sm" rows={2} maxLength={255}
                          placeholder="Or type a reason" value={text} onChange={e => setText(e.target.value)} />
                {error && <p className="text-sm text-red-700 mt-2">{error}</p>}
                <div className="mt-4 flex justify-end gap-2">
                    <button type="button" onClick={onClose} className="px-3 py-1.5 text-sm border border-gray-300 rounded">Cancel</button>
                    <button type="button" onClick={save} disabled={busy || text.trim() === ''}
                            className="px-3 py-1.5 text-sm rounded bg-indigo-600 text-white disabled:bg-indigo-300">Skip</button>
                </div>
            </div>
        </div>
    );
}
